/* One sale clock for the EVO landing page and product page. All dates include ET offsets. */
(function () {
  if (window.AipiEvoSale) return;
  var start = Date.parse('2026-10-16T00:00:00-04:00');
  var end = Date.parse('2026-10-25T12:00:00-04:00');
  var serverTime = null;
  var measuredAt = 0;
  var timer;
  var retryTimer;
  var retryDelay = 2000;
  var inFlight;
  var product = null;
  function now() {
    return serverTime === null ? Date.now() : serverTime + (performance.now() - measuredAt);
  }
  function state(at) {
    at = typeof at === 'number' ? at : now();
    return { phase: at < start ? 'upcoming' : at < end ? 'early-bird' : 'regular', open: at >= start, expectedPrice: at < end ? 4999 : 5999, product: product };
  }
  function publish() {
    var current = state();
    document.querySelectorAll('[data-evo-sale-early][data-evo-sale-regular]').forEach(function (node) {
      node.textContent = node.getAttribute(current.phase === 'regular' ? 'data-evo-sale-regular' : 'data-evo-sale-early');
    });
    window.dispatchEvent(new CustomEvent('aipi:evo-sale-state', { detail: current }));
    clearTimeout(timer);
    var next = now() < start ? start : now() < end ? end : null;
    if (next !== null) timer = setTimeout(function () { publish(); refresh(); }, Math.min(Math.max(next - now() + 100, 100), 2147483000));
  }
  function retryPendingPrice() {
    clearTimeout(retryTimer);
    var current = state();
    // The scheduled Shopify import can finish a few seconds after the deadline.
    // Refresh already-open tabs until the real price catches up, for up to 15 minutes.
    var pending = current.phase === 'regular' && now() < end + 15 * 60 * 1000 &&
      (!product || !product.variants.length || product.variants.some(function (variant) { return variant.price !== current.expectedPrice; }));
    if (pending && !document.hidden) {
      retryTimer = setTimeout(refresh, retryDelay);
      retryDelay = Math.min(retryDelay * 2, 15000);
    } else {
      retryDelay = 2000;
    }
  }
  function refresh() {
    if (inFlight) return inFlight;
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 8000);
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    inFlight = fetch(root + 'products/aipi-lite-evo.js?evo_clock=' + Date.now(), { cache: 'no-store', credentials: 'same-origin', signal: controller.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Product refresh unavailable');
        var date = Date.parse(response.headers.get('Date'));
        if (Number.isFinite(date)) { serverTime = date; measuredAt = performance.now(); }
        return response.json();
      })
      .then(function (data) { if (Array.isArray(data.variants)) product = data; })
      .catch(function () { /* Keep the rendered fallback; Shopify validates inventory on add-to-cart. */ })
      .finally(function () { clearTimeout(timeout); inFlight = null; publish(); retryPendingPrice(); });
    return inFlight;
  }
  window.AipiEvoSale = { start: start, end: end, now: now, state: state, refresh: refresh };
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { publish(); refresh(); } });
  publish();
  refresh();
})();
